export default "__VITE_ASSET__C9u4F7g3__"